import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  stickIcon: createResponsiveStyles({
    base: {
      position: "absolute",
      top: theme.spacing.medium,
      right: theme.spacing.medium,
    },
    small: {
      top: theme.spacing.xsmall,
      right: theme.spacing.xsmall,
    },
    xlarge: {
      top: -theme.spacing.xlarge3,
    },
  }),

  panelsWrapper: createResponsiveStyles({
    base: {
      flex: 1,
      alignItems: "flex-end",
      marginTop: theme.spacing.xlarge3,
    },
  }),
  panelText: createResponsiveStyles({
    base: {
      marginTop: theme.spacing.xlarge3,
      fontFamily: "ProximaSemiBold",
      minHeight: theme.spacing.xlarge3,
      maxWidth: "70%",
    },
    xlarge: {
      maxWidth: "100%",
    },
  }),
});
